// Desenho comum da app — as mesmas cores e peças do módulo Comissões e Recebimentos (src/ComissoesRecebimentos.js).
// Cada cor tem uma função fixa: não trocar o significado.
// Usar estas peças nos ecrãs que forem sendo revistos, um módulo de cada vez.

export const ds = {
  linha: "#e6e3dc",      // contornos e separadores
  tinta: "#17213a", tinta2: "#4f586b", tinta3: "#8a909d",
  navy9: "#12244f", navy7: "#1e3a7a", navy1: "#e3e9f5", navy0: "#f1f4fa", // ação principal, cabeçalhos, "Reportado"
  ok: "#0f7a47", okFundo: "#dcf5e6",       // recebido, concluído, Comprador
  atencao: "#9a5a05", atencaoFundo: "#fdf0cf", // pendente
  falta: "#b3261e", faltaFundo: "#fbe1df",  // em falta, erro, bloqueado
  ext: "#8a909d", extFundo: "#eeeef0",      // partilha, outra agência, colega
  angariador: "#1e4fa3", angariadorFundo: "#dfe9fb",
  gradiente: "linear-gradient(135deg,#1b2f66,#12244f)",
  letra: "'DM Sans', sans-serif", titulo: "'Playfair Display', serif",
};

const TONS = {
  ok: [ds.ok, ds.okFundo], atencao: [ds.atencao, ds.atencaoFundo], falta: [ds.falta, ds.faltaFundo],
  ext: [ds.ext, ds.extFundo], navy: ["#fff", ds.navy9], info: [ds.navy9, ds.navy1],
};

// Etiqueta redonda de estado (ex.: "✓ Concluído", "⏳ falta", "Out 26")
export function Etiqueta({ tom = "info", children, title }) {
  const [cor, fundo] = TONS[tom] || TONS.info;
  return <span title={title} style={{ display: "inline-flex", alignItems: "center", gap: 4, borderRadius: 99, padding: "2px 10px", fontSize: 12, fontWeight: 700, whiteSpace: "nowrap", color: cor, background: fundo }}>{children}</span>;
}

// Legenda: o significado de cada etiqueta, no topo das listas
export function Legenda({ itens }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center", fontSize: 12, color: ds.tinta2 }}>
      {itens.map(([tom, nome, explica]) => <span key={nome} style={{ display: "inline-flex", gap: 6, alignItems: "center" }}><Etiqueta tom={tom}>{nome}</Etiqueta>{explica && <span>{explica}</span>}</span>)}
    </div>
  );
}

// Campo obrigatório: asterisco na etiqueta e o erro escrito por baixo do campo
export const Obrigatorio = () => <span style={{ color: ds.falta }} aria-hidden="true"> *</span>;
export const ErroCampo = ({ chave, erro }) => erro ? <div role="alert" data-erro-campo={chave} style={{ color: ds.falta, fontSize: 12, fontWeight: 600, marginTop: 4 }}>⚠ {erro}</div> : null;

// Código do registo (LEAD/ANG/PROP/NEG/CPCV-AA-NNNN). Aparece ao lado do ID do imóvel, que continua a ser a referência.
export const Codigo = ({ valor, style }) => valor ? <span title="Código do registo" style={{ display: "inline-flex", borderRadius: 6, padding: "1px 7px", fontSize: 11.5, fontWeight: 700, fontFamily: "ui-monospace, Menlo, monospace", color: ds.navy9, background: ds.navy1, whiteSpace: "nowrap", verticalAlign: "middle", ...style }}>{valor}</span> : null;

// Número do processo: o negócio dá o número a todo o processo (NEG-26-0065 → PROP-26-0065, CPCV-26-0065, ESC-26-0065, COM-26-0065)
export const codigoProcesso = (prefixo, codigoNegocio) => {
  const i = String(codigoNegocio || "").indexOf("-");
  return i > 0 ? prefixo + String(codigoNegocio).slice(i) : null;
};
